export default __webpack_public_path__ + "static/media/down-up-up.2891c9c6.svg";